<template>
  <div>
    <div class="form-group col-md-4">
      <label :for="'questionDropdown' + index ">{{
          _t("Question")
        }}</label>
      <select :disabled="true" v-model="question_id" class="form-control"
              :id="'questionDropdown' + index">
        <option value="" selected>{{ _t("Select...") }}</option>
        <option v-for="question in questions" :key="question.id" :value="question.id">
          {{ question.text }} ({{ _t(question.type) }})
        </option>
      </select>
    </div>
    <div class="form-group col-md-3">
      <label :for="'operatorDropdown' + index ">{{
          _t("Operator")
        }}</label>
      <select
          v-model="operator"
          class="form-control"
          :id="'operatorDropdown' + index "
          :disabled="true"
      >
        <option value="" selected>{{ _t("Select...") }}</option>
        <option value="equals">
          {{ _t("=") }}
        </option>
        <option value="less_than">{{ _t("<") }}</option>
        <option value="greater_than">{{ _t(">") }}</option>
      </select>
    </div>
    <div v-if="isAnswerDropdown(question_id)" class="form-group col-md-4">
      <label :for="'answerDropdown' + index">{{ _t("Answer") }}</label>
      <select :disabled="true" v-model="selectedAnswers" class="form-control"
              :id="'answerDropdown' + index"
              :multiple="isMultiAnswer(question_id)">
        <option value="" selected>{{ _t("Select...") }}</option>
        <option v-for="answer in getAnswers(question_id)" :key="answer.id"
                :value="answer.id">{{ answer.text }}
        </option>
      </select>
    </div>
    <div v-else class="form-group col-md-4">
      <label :for="'answerInput' + index">{{ _t("Answer") }}</label>
      <input :disabled="true" v-model="inputAnswer" type="text" class="form-control"
             :id="'answerInput' + index">
    </div>

  </div>
</template>

<script>
export default {
  name: "ShowRuleDefinition",
  props: [
    'questions',
    'index',
    'ruleId',
    'question_id',
    'operator',
    'selectedAnswers',
    'inputAnswer',
    'definitionId'
  ],

  methods: {

    getAnswers(questionId) {
      const selectedQuestion = this.questions.find(q => q.id === questionId);

      return selectedQuestion ? selectedQuestion.answers : [];
    },
    isAnswerQuestion(questionId) {
      const selectedQuestion = this.questions.find(q => q.id === questionId);

      const isAnswerQuestion = selectedQuestion && (selectedQuestion.type === 'single_answer' || selectedQuestion.type === 'multi_answer');

      if (isAnswerQuestion) {
        this.operator = 'equals'
      }

      return isAnswerQuestion;
    },
    isMultiAnswer(questionId) {
      const selectedQuestion = this.questions.find(q => q.id === questionId);
      return selectedQuestion && selectedQuestion.type === 'multi_answer';
    },
    isAnswerDropdown(questionId) {
      const selectedQuestion = this.questions.find(q => q.id === questionId);
      const isDropdown = selectedQuestion && (selectedQuestion.type === 'single_answer' || selectedQuestion.type === 'multi_answer');

      return isDropdown;
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/ShowRuleDefinition.vue